var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.15741 2.83333C3.80624 2.83333 3.46946 2.97283 3.22115 3.22114C2.97283 3.46945 2.83333 3.80624 2.83333 4.1574V19.8703L5.74997 16.9537C5.92188 16.7817 6.15503 16.6852 6.39815 16.6852H19.8426C20.1938 16.6852 20.5305 16.5457 20.7789 16.2974C21.0272 16.049 21.1667 15.7123 21.1667 15.3611V4.1574C21.1667 3.80624 21.0272 3.46945 20.7789 3.22114C20.5305 2.97283 20.1938 2.83333 19.8426 2.83333H4.15741ZM1.92478 1.92478C2.51691 1.33265 3.32001 1 4.15741 1H19.8426C20.68 1 21.4831 1.33265 22.0752 1.92478C22.6673 2.51691 23 3.32001 23 4.1574V15.3611C23 16.1985 22.6673 17.0016 22.0752 17.5937C21.4831 18.1858 20.68 18.5185 19.8426 18.5185H6.77784L2.56485 22.7315C2.30268 22.9937 1.90841 23.0721 1.56587 22.9302C1.22334 22.7883 1 22.4541 1 22.0833V4.1574C1 3.32001 1.33265 2.51691 1.92478 1.92478Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 4.66666H12.9167V12H11.0833V4.66666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 12.9167H12.9167V14.75H11.0833V12.9167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconWarning);
export default __webpack_public_path__ + "static/media/button-icon-warning.c33a5e210c8d91eb82536a87e0a3f469.svg";
export { ForwardRef as ReactComponent };